<div *ngIf='formReady && dataReady' [formGroup]='inputForm'>
  <div class='row'>
    <div class='col col-md-2'>Subject:</div>
    <div class='col col-md-10'>
      <mat-form-field>
        <input formControlName='subject' matInput name='subject' />
      </mat-form-field>
    </div>
  </div>

  <div class='row'>
    <div class='col col-md-2'>Message:</div>
    <div class='col col-md-10'>
      <app-editor formControlName='reply_content'></app-editor>
    </div>
  </div>
</div>
